module.exports = __webpack_public_path__ + "media/images/client-23-f39e79b17615195db8a55e2b69789a03.png";